import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const FLAG_BASE_PATH = '/img/flags/3x2';
const FALLBACK_CODE = 'eu';
const CODE_PATTERN = /^[a-z]{2}$/;

const normalizeCode = (code) =>
  typeof code === 'string' ? code.trim().toLowerCase() : '';

const FlagIcon = ({ countryCode, alt, decorative }) => {
  const normalized = normalizeCode(countryCode);
  const validCode = CODE_PATTERN.test(normalized) ? normalized : null;
  const src = `${FLAG_BASE_PATH}/${validCode || FALLBACK_CODE}.svg`;

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = `${FLAG_BASE_PATH}/${FALLBACK_CODE}.svg`;
  };

  const baseAlt = alt || validCode || FALLBACK_CODE;
  const altText = decorative ? '' : baseAlt;

  return (
    <img
      className={classNames('FlagIcon', { [validCode]: validCode })}
      src={src}
      alt={altText}
      aria-hidden={decorative ? 'true' : undefined}
      onError={handleError}
      loading="lazy"
      height={'12px'}
    />
  );
};

FlagIcon.propTypes = {
  countryCode: PropTypes.string.isRequired,
  alt: PropTypes.string,
  decorative: PropTypes.bool,
};

FlagIcon.defaultProps = {
  alt: undefined,
  decorative: false,
};

export default FlagIcon;
